export const STATUSES = ["Lead Captured", "Documents Uploaded", "File Logged In", "Valuation Initiated", "Sanctioned", "Disbursed"];
export const LOAN_TYPES = ["Home Loan", "LAP", "Business Loan"];
export const DOC_TYPES = ["PAN", "Aadhar", "Bank Statement", "Property Chain"];

export const STATUS_COLORS = {
  "Lead Captured": "#60A5FA",
  "Documents Uploaded": "#818CF8",
  "File Logged In": "#F59E0B",
  "Valuation Initiated": "#A855F7",
  Sanctioned: "#10B981",
  Disbursed: "#059669",
};

export const STATUS_HINTS = {
  "Lead Captured": "We have received your request. Upload your documents so we can shortlist the right partner banks.",
  "Documents Uploaded": "Our team is reviewing your KYC and financials and matching you with partner lenders.",
  "File Logged In": "Your file has been logged in with the partner bank — credit assessment is underway.",
  "Valuation Initiated": "The bank's certified valuer and legal team are assessing the property.",
  Sanctioned: "Congratulations — the partner bank has sanctioned your loan.",
  Disbursed: "Funds have been disbursed by the bank. Welcome to the Falcon family.",
};

export const RATES = { "Home Loan": 7.1, LAP: 8.5, "Business Loan": 8.6 };
export const PREFILL_KEY = "ff_prefill";

export const calcEmi = (principal, rate, years) => {
  const r = rate / 1200;
  const n = Math.max(1, years) * 12;
  if (!principal || !r) return 0;
  return (principal * r * Math.pow(1 + r, n)) / (Math.pow(1 + r, n) - 1);
};

export const calcMaxLoan = (income, rate, years, foir = 0.5) => {
  const r = rate / 1200;
  const n = Math.max(1, years) * 12;
  const maxEmi = income * foir;
  return (maxEmi * (Math.pow(1 + r, n) - 1)) / (r * Math.pow(1 + r, n));
};

export const slug = (s) => s.toLowerCase().replace(/\s+/g, "-");
